import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './installation.component'

let module = angular.module('installation', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('installation', {
      url: '/installation?token',
      params: { success: null },
      component: 'installation',
      authenticate: true
    })
})
.component('installation', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/installation/index.js